import React, { useEffect } from 'react'
import styles from "./index.module.scss"
import useQuery from '@/hooks/useQuery'
import request from '@/network/request'
// import { points1, points5, points7 } from './gps-points'

// 设计稿canvas轨迹颜色
const TRIPS_LINE_COLOR = '#1990FF'
// 设计稿canvas轨迹宽度
const TRIPS_LINE_WIDTH = 4
// 设计稿canvas画布宽高number(100%=3.75)
const CANVAS_WIDTH = 3.75
// 设计稿canvas icon宽高
const ICON_WIDTH = 35
const ICON_HEIGHT = 35
// canvas icon
const ICON_START_SRC = require('../assets/depart.png')
const ICON_END_SRC = require('../assets/destination.png')
// 解决canvas模糊问题配置的css scale值
const CSS_SCALE = 0.6

const App = () => {
  const vin = useQuery().get('vin') || ''
  const routeId = useQuery().get('routeId') || ''

  useEffect(() => {
    document.title = 'AI代驾路线管理'
    getCommuteRoutes()
  }, [])

  const getCommuteRoutes = async () => {
    try {
      const data: any = await request('/biz/v5/fngp/getCommuteRoutes', { vin }, 'POST')
      if (data?.routes?.length > 0) {
        const currentRoute = data?.routes.filter((item: any) => item.id === Number(routeId))[0]
        const lonLatH = currentRoute?.trajectoryBrief?.lonLatH
        const points: {x: string, y: string}[] = []
        !!lonLatH?.length && lonLatH.forEach((item: any) => {
          points.push({
            x: item.lon,
            y: item.lat
          })
        })

        drawRoute(points)
      }
    } catch (error) {
      console.log('getCommuteRoutes error --> ', error)
    }
  }

  /**
   * 画路线轨迹
   * @param points 
   */
  const drawRoute = (points) => {
    // 处理经纬度数据
    points = formatPoints(points)

    const canvas = document.getElementById('canvas') as HTMLCanvasElement

    if (canvas && points?.length) {
      // 移动端canvas不支持rem，这里转换为px(1px=0.01rem 以设计稿宽度375px为准)
      const currentFontSize = document.body.clientWidth * 100 / 375
      console.log('currentFontSize', currentFontSize)

      // #root设置了最大宽度为750px
      const canvasWidthAndHeight = CANVAS_WIDTH * currentFontSize > 750 ? 750 : CANVAS_WIDTH * currentFontSize
      canvas.setAttribute('width', `${canvasWidthAndHeight}px`)
      canvas.setAttribute('height', `${canvasWidthAndHeight}px`)

      console.log('canvas width and height -->', canvas.width, canvas.height)

      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D

      ctx.strokeStyle = TRIPS_LINE_COLOR;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      // 将canvas画出的行程轨迹在画布居中，取x、y的中位数(缩放后)，再减去画布宽高的一半(缩放后)，做位移
      const allX = points.map(item => item.x)
      const maxX = Math.max(...allX)
      const minX = Math.min(...allX)
      const middleX = (maxX + minX) / 2

      const allY = points.map(item => item.y)
      const maxY = Math.max(...allY)
      const minY = Math.min(...allY)
      const middleY = (maxY + minY) / 2
      
      console.log('points -->', points)
      console.log('maxX minX maxY minY "maxX-minX" "maxY-minY" -->', maxX, minX, maxY, minY, maxX-minX, maxY-minY)
      console.log('middleX middleY -->', middleX, middleY)

      // 根据整体轨迹图案宽高的最大值，来计算相对canvas画布大小需要缩放的倍数
      let scaleNum = 1
      if (maxX-minX > maxY-minY) {
        scaleNum = canvas.width / (maxX-minX)
      } else {
        scaleNum = canvas.height / (maxY-minY)
      }

      // 倍数减少以防止icon被边界截断
      scaleNum = scaleNum - scaleNum / 6
      
      console.log('scaleNum --> ', scaleNum)
      // 缩放适应轨迹宽高
      ctx.scale(scaleNum, scaleNum)
      // 画布整体缩放，解决模糊问题，画布相对页面进行排版的时候需要特殊处理
      canvas.setAttribute('style', `transform:scale(${CSS_SCALE})`)

      // 缩放后再定义线宽
      const scaleLineWidth = TRIPS_LINE_WIDTH / scaleNum / CSS_SCALE
      ctx.lineWidth = scaleLineWidth

      // 缩放后icon大小跟随变化，要随之恢复
      const scaleIconWidth = ICON_WIDTH / scaleNum / CSS_SCALE
      const scaleIconHeight = ICON_HEIGHT / scaleNum / CSS_SCALE

      // 将canvas实例位移至画布中心
      ctx.translate(-middleX + canvas.width / 2 / scaleNum, -middleY + canvas.height / 2 / scaleNum)

      // （预留）分段画轨迹
      const segmentedArray = [points]

      console.log('segmentedArray --> ', segmentedArray)

      // 分段画轨迹
      if (segmentedArray.length) {
        segmentedArray.forEach((item, index) => {
          ctx.beginPath()

          // 分段以后ctx绘制起点要移动到上一段的末尾点，防止绘制轨迹断开
          if (index > 0) {
            const lastItem = segmentedArray[index - 1]
            console.log('分段连接处 --> ', index, lastItem[lastItem.length - 1].x, item[0].x)
            ctx.moveTo(lastItem[lastItem.length - 1].x, lastItem[lastItem.length - 1].y)
          }

          item?.forEach((subItem, subIndex) => {
            // 画起点icon
            if (index === 0 && subIndex === 0) {
              const iconStart = new Image()
              iconStart.src = ICON_START_SRC
              iconStart.onload = function () {
                // ctx.drawImage(iconStart, subItem.x - scaleIconWidth / 2, subItem.y - scaleIconHeight / 2, scaleIconWidth, scaleIconHeight)
                ctx.drawImage(iconStart, subItem.x - scaleIconWidth / 2 - scaleLineWidth / 4, subItem.y - scaleIconHeight / 2 - scaleLineWidth, scaleIconWidth, scaleIconHeight)
              }
            }
            // 画终点icon
            if (index === segmentedArray.length - 1 && subIndex === item.length - 1) {
              const iconEnd = new Image()
              iconEnd.src = ICON_END_SRC
              iconEnd.onload = function () {
                // ctx.drawImage(iconEnd, subItem.x - scaleIconWidth / 2, subItem.y - scaleIconHeight / 2, scaleIconWidth, scaleIconHeight)
                ctx.drawImage(iconEnd, subItem.x - scaleIconWidth / 2 - scaleLineWidth / 4, subItem.y - scaleIconHeight / 2 - scaleLineWidth, scaleIconWidth, scaleIconHeight)
              }
            }
            ctx.lineTo(subItem.x, subItem.y)
          })

          ctx.stroke()
        })
      }
    }
  }

  /**
   * x,y对应经度、纬度（y取反，纬度增加位移向上），服务端返回100个点
   * 这里因为经纬度变化都集中在小数点第三位以后，所以先移动小数点到第六位，再缩小取到整数，此时变化幅度较为合适
   * 数据不足6位小数的 补足6位
   * @param points
   * @returns 
   */
  const formatPoints = (points: { x: any, y: any, a: any }[]) => {
    const renderPoints = !!points?.length && points.map(item => {
      item.x = Number(item.x).toFixed(6)
      item.y = Number(item.y).toFixed(6)
      return {
        ...item,
        x: Number((+((item.x * 1000000).toString().slice(1)) / 5000).toFixed(2)), // 精度的变化主要集中在后几位，把几乎不变的第一位排除在外，再缩小取整，保持变化幅度合适
        y: -Number((+((item.y * 1000000).toString()) / 5000).toFixed(2))
      }
    })
    console.log('renderPoints --> ', renderPoints)
    return renderPoints
  }

  return (
    <div className={styles.homePage}>
      <div className={styles.canvasContainer}>
        <canvas id="canvas"></canvas>
      </div>
    </div>
  )
}

export default App